import { useNavigate } from "react-router-dom";
import { classNames } from "../utils/functions";
import { ItemUsageCardProps } from "../../types/Profile";

export default function ItemUsageCard({ item, type }: ItemUsageCardProps) {
  const navigate = useNavigate();
  
  const handleClick = () => {
    navigate(`/wardrobe/item/${item.id}`);
  };
  
  return (
    <div 
      onClick={handleClick}
      className="group relative overflow-hidden rounded-lg bg-white dark:bg-gray-800 shadow-sm hover:shadow-lg transition-all duration-300 cursor-pointer hover:scale-105">
      {/* Click overlay for better accessibility */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/5 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      <div className="aspect-square overflow-hidden">
        <img
          src={item.imageUrl}
          alt={item.item}
          className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
        />
      </div>
      
      {/* Usage Badge */}
      <div className={classNames(
        type === 'most' ? 'bg-green-500' : 'bg-amber-500',
        'absolute top-2 left-2 rounded-full px-2 py-1 text-xs font-light text-white'
      )}>
        {item.usageCount}x
      </div>
      
      <div className="p-4 relative z-10">
        <h4 className="text-sm font-light tracking-wider uppercase text-gray-900 dark:text-white group-hover:text-gray-700 dark:group-hover:text-gray-200 transition-colors duration-300">
          {item.item}
        </h4>
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
          {item.category}
        </p>
        <p className="mt-2 text-xs text-gray-400 dark:text-gray-500">
          Last worn: {new Date(item.lastUsed).toLocaleDateString()}
        </p>
        
        {/* Click indicator */}
        <div className="mt-2 flex items-center text-xs text-gray-400 dark:text-gray-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span>Click to view details</span>
          <svg className="ml-1 h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </div>
      </div>
    </div>
  );
}